import { SeaCalculatedChargesModel } from "./sea-calculated-charges.model";
import {AirCalculatedChargesModel} from "../air/air-calculated-charges.model";
import { FrontEndTariffModel } from "../front-end-tariff.model";

export class SeaCalculatedFreightModel {
    uuid: string;
    newProductUuid: string;
    seaFreightTariffDetId: number;
    unitPrice: number;
    unitBuyingFreight: number;
    tonnage: number;
    setTariffTonnage: number;
    containerType: string;
    containerCount: number;
    totalFreight: number;
    grandTotal: number;
    currencyRate; //kur cevrimi içi: number;
    tariffCurrency: string;
    currency: string;
    errorCode: string;
    freeTime: number;
    isMinFreight: boolean;
    freightTariffValidFrom: Date;
    freightTariffValidTo: Date;
    freightTariffDetValidFrom: Date;
    freightTariffDetValidTo: Date;
    discountCode: string;
    discountUuid: string;
    originCharges: SeaCalculatedChargesModel[] = [];
    insuranceCharge: SeaCalculatedChargesModel;
    agencyFeeCharge: SeaCalculatedChargesModel;
    destinationCharges: SeaCalculatedChargesModel[] = [];
    perFreightCharges: SeaCalculatedChargesModel[] = [];
    etd: Date;
    eta: Date;
    cutOffDate: Date;
    shipInfo: string;
    shipOwner: string;
    isLastPrice: boolean = false;
    availableTonnage: number;
    viaPorts: string;
    viaPortCountryCode: string;
    viaPortCode: string;
    viaPortDTOList: any[] = [];
    serviceDescription: string;

    frontTariff:FrontEndTariffModel;
    endTariff:FrontEndTariffModel;
}
